import dayjs from 'dayjs';

import type { DateKeyType } from 'types/commonTypes';
import { convertDateToServerStrFormat } from 'utils/timeHelper';
import { SERVER_DATE_FORMAT } from 'constants/mainConstants';

interface IDateRange {
  from: DateKeyType | null;
  to: DateKeyType | null;
}

export function generateDateArray(
  startDate: DateKeyType,
  dateRange: IDateRange,
): DateKeyType[] {
  try {
    const result: DateKeyType[] = [];

    const from = convertDateToServerStrFormat(dateRange.from ?? null);
    const to = convertDateToServerStrFormat(dateRange.to ?? null);

    const startDateObj = dayjs(startDate);
    const fromDate = dayjs(from);
    const toDate = dayjs(to);

    if (fromDate.isValid() && toDate.isValid() && toDate.diff(fromDate, 'day') < 0) {
      throw new Error('Invalid date range: "from" date must be before "to" date');
    }

    const xStartDate = fromDate.isValid()
      ? fromDate
      : startDateObj;

    const xEndDate = toDate.isValid()
      ? toDate
      : dayjs();

    const diffInDays = Math.abs(xEndDate.diff(xStartDate, 'day'));

    for (let i = 0; i <= diffInDays; i++) {
      const currentDate = xStartDate.add(i, 'day').format(SERVER_DATE_FORMAT);
      result.push(currentDate as DateKeyType);
    }

    return result;
  } catch (error) {
    console.error(error);
    return [];
  }
}
